<template>
  <v-footer
    dark
    padless
    app
    fixed
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="primary py-1">
        <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <a 
            href="https://www.controlroomsrl.com/"
            target="_blank"
            v-bind="attrs"
            v-on="on">
            <v-img
              alt="Control Room logo"
              contain
              class="shrink"
              :src="require('@/assets/logo-control-room.png')"
              transition="scale-transition"
              width="125"
            />
          </a>
          </template>
        <span class="oswald"> Vai a Control Room </span>
      </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip 
          v-for="item in links"
          :key="item.link" 
          top
        >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="mx-2"
            dark
            icon
            :href="item.link"
            target="_blank"
          >
            <v-icon size="24px">
              {{ item.icon }}
            </v-icon>
          </v-btn>
        </template>
        <span class="oswald">{{ item.tooltip }}</span>
      </v-tooltip>
      </v-card-title>

      <v-card-text class="py-2 white--text text-center d-none d-sm-block">
        {{ new Date().getFullYear() }} — <strong>Control Room </strong> Sede Legale: Via Quartirolo, 13 - 47923 Rimini (RN) - Italy - Sede Operativa: Centro Direzionale Futuro Via Ariete, 18 - 47923 Rimini (RN)
      </v-card-text>
      <v-card-text class="py-2 white--text text-center d-block d-sm-none">
        {{ new Date().getFullYear() }} — <strong>Control Room </strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
  export default {
    name: 'Footer',
    data: () => ({
      links: [
        {icon:'mdi-facebook', link:'https://www.facebook.com/controlroomsrl/', tooltip:'Seguici su Facebook'},
        {icon:'mdi-instagram', link: 'https://www.instagram.com/controlroomsrl/', tooltip:'Seguici su Instagram'},
        {icon:'mdi-email-outline', link: 'mailto:info@controlroomsrl.com',tooltip: 'Mandaci una mail'},
      ],
    }),
  }
</script>